export class DropDownPagingInput {
  public constructor(
    endPoint: string,
    showFieldName: string,
    searchFieldName: string,
    hasAdd: boolean,
    hasPaging: boolean,
    hasSearch: boolean,
    isValid:boolean,
    isDisable:boolean,
    
    relationId?: string,
    relationName?: string,
    buttonClass?: string,
    defaultValue?: string,
    fieldNames?: string[]
  ) {
    this.endPoint = endPoint;
    this.showFieldName = showFieldName;
    this.searchFieldName = searchFieldName;
    this.hasAdd = hasAdd;
    this.isValid = isValid;
    this.isDisable = isDisable;
    this.hasPaging = hasPaging;
    this.hasSearch = hasSearch;
    this.relationId = relationId;
    this.relationName = relationName;
    this.buttonClass = buttonClass;
    this.defaultValue = defaultValue;
    this.fieldNames=fieldNames;
    this.hasRefreshButton=false;
  }

  public endPoint: string;
  public showFieldName: string;
  public searchFieldName: string;
  public hasAdd: boolean;
  public hasPaging: boolean;
  public hasRefreshButton: boolean;
  public hasSearch: boolean;
  public isValid: boolean;
  public isDisable: boolean;
  public relationId?: string;
  public relationName?: string;
  public buttonClass?: string;
  public defaultKey?: string;
  public defaultValue?: string;
  public fieldNames?: string[];
}
